module.exports = __webpack_public_path__ + "static/media/material_60yd_y-1.6f07f85d.csv";